var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "white",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2286 5.83333C19.1182 5.83333 21.8894 6.92904 23.9327 8.87942C25.9759 10.8298 27.1238 13.4751 27.1238 16.2333C27.1238 18.8093 26.1349 21.1773 24.509 23.0013L24.9615 23.4333H26.2857L34.6667 31.4333L32.1524 33.8333L23.7714 25.8333V24.5693L23.3189 24.1373C21.408 25.6893 18.9272 26.6333 16.2286 26.6333C13.339 26.6333 10.5677 25.5376 8.52448 23.5872C6.48123 21.6369 5.33334 18.9916 5.33334 16.2333C5.33334 13.4751 6.48123 10.8298 8.52448 8.87942C10.5677 6.92904 13.339 5.83333 16.2286 5.83333ZM16.2286 9.03333C12.0381 9.03333 8.68572 12.2333 8.68572 16.2333C8.68572 20.2333 12.0381 23.4333 16.2286 23.4333C20.4191 23.4333 23.7714 20.2333 23.7714 16.2333C23.7714 12.2333 20.4191 9.03333 16.2286 9.03333Z",
    strokeWidth: 1.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f6d9421dfecabfb4198a227335fee58b.svg";
export { ForwardRef as ReactComponent };